import { useMutation } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { DuplicateQuoteDocument } from './graphql/duplicateQuote.gql';

interface UseDuplicateQuoteArgs {
  quoteId: string;
}

const useDuplicateQuote = ({ quoteId }: UseDuplicateQuoteArgs) => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfile is undefined in useDuplicateQuote hook');
  }

  return useMutation(DuplicateQuoteDocument, {
    awaitRefetchQueries: true,
    variables: { input: { quoteId } },
  });
};
export default useDuplicateQuote;
